var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.label)?_c('div',{staticClass:"document-list-item-viewer-availability",class:{ '-small': _vm.variant === 'small' || _vm.variant === 'toc' || _vm.variant === 'directory' }},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }